import { WalkthroughPage } from '../types';

export const CATALOG_WALKTHROUGH_TITLE = 'Welcome to the catalog';

export const CATALOG_WALKTHROUGH_STORAGE_KEY = 'catalog-walkthrough-seen';

export const catalogWalkthroughPages: WalkthroughPage[] = [
  {
    title: 'General information',
    content: (
      <p>
        The catalog is our central hub for software in Arla — services, APIs,
        websites, libraries, and more. Browse, search, and filter to find
        anything your team and other teams own or depend on.
      </p>
    ),
  },
  {
    title: 'Creating components',
    content: (
      <>
        <p>
          Add new software to the catalog using the{' '}
          <strong>Create button</strong> in the top right.
        </p>
        <p>
          Choose from ready-made templates to scaffold a new project from
          scratch, or use <strong>Register Existing Component</strong> to add
          something already built by pointing to its catalog-info.yaml file in
          your repo.
        </p>
      </>
    ),
  },
  {
    title: 'TechDocs',
    content: (
      <>
        <p>
          Each component can have built-in documentation. Look for the Docs tab
          on any component page to read technical guides written and maintained
          directly alongside the code.
        </p>
        <p>
          To register documentation click on the <strong>create button</strong>{' '}
          and use the <strong>Enable Techdocs template</strong> or
          register your existing component to have your documentation visible
          and searchable in the portal.
        </p>
      </>
    ),
  },
  {
    title: 'Feedback or comments',
    content: (
      <>
        <p>
          The developer portal is made for you, and therefore we appreciate any
          feedback or wishes you might have, e.g., new functionality and tools
          to incorporate, new templates for making your tasks easier or general
          feedback on improvements.
        </p>
        <br/>
        <p>
          Reach out to the Developer Enablement product team on <a href="mailto:PlatformsDeveloperEnablement@arlafoods.com" style={{color: 'var(--arla-anchor-color)'}}>PlatformsDeveloperEnablement@arlafoods.com</a> for any
          feedback, wishes or ideas.
        </p>
      </>
    ),
  },
];
